import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = ({ isEditing }: { isEditing: boolean }) =>
  makeStyles((theme: Theme) => ({
    container: {
      marginTop: theme.spacing(5),
      rowGap: theme.spacing(5),
    },
    headerContainer: {
      alignItems: "center",
      columnGap: theme.spacing(5),
    },
    profileIcon: {
      width: theme.spacing(9),
      height: theme.spacing(9),
    },
    name: {
      fontSize: theme.spacing(4),
      fontWeight: 800,
    },
    tabs: {
      backgroundColor: "#F2F2F2",
      minHeight: theme.spacing(5), // Add minHeight to the container
      height: theme.spacing(5),
      borderRadius: theme.spacing(1),
    },
    tab: {
      color: "black",
      width: theme.spacing(32),
      height: theme.spacing(5), // Increase height
      minHeight: theme.spacing(5), // Add minHeight
      "&.Mui-selected": {
        backgroundColor: "black",
        color: "white",
        borderRadius: "8px",
      },
    },
    contentContainer: {
      padding: theme.spacing(5),
      borderRadius: theme.spacing(1),
      rowGap: theme.spacing(3),
      border: `1px solid #DBDBDB`,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    editButton: {
      width: theme.spacing(25),
    },
    button: {
      backgroundColor: "black",
      width: theme.spacing(25),
    },
    profileColumnContainer: {},
    profileRow: {
      alignItems: "center",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      borderBottom: isEditing ? "none" : "1px solid #DBDBDB",
    },
    backgroundImageContainer: {
      width: theme.spacing(17),
    },
    checkbox: {
      borderRadius: theme.spacing(1),
      backgroundColor: "#FFF",
      justifySelf: "flex-end",
      margin: 0,
      borderBottom: 0,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    // sx={{
    //                         "&.MuiRadio-root": {
    //                           color: "your_inactive_color_here", // This colors the border when inactive
    //                         },
    //                         "&.Mui-checked": {
    //                           color: theme.palette.primary.main, // This maintains your active color
    //                         },
    //                       }}
    radio: {
      "&.MuiRadio-root": {
        color: theme.palette.primary.main, // This colors the border when inactive
      },
      "&.Mui-checked": {
        color: theme.palette.primary.main, // This maintains your active color
      },
    },
    signatureCanvas: {
      width: "100%",
      height: "100%",
      borderBottom: "1px solid #000",
    },
  }));

export default useStyles;
